
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class ExtensionFieldGrid extends SiteEntityGrid<ExtensionFieldRow, any> {
        protected getColumnsKey() { return 'Data.ExtensionField'; }
        protected getDialogType() { return ExtensionFieldDialog; }
        protected getIdProperty() { return ExtensionFieldRow.Fields.FieldName; }
        protected getLocalTextPrefix() { return ExtensionFieldRow.localTextPrefix; }
        protected getService() { return ExtensionFieldService.baseUrl; }

        private schemaAndTable: Serenity.LookupEditor;

        constructor(container: JQuery) {
            super(container);

            this.schemaAndTable = Serenity.Widget.create({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: 'Data.ExtensionTable'
                },
                init: ed => {
                    ed.value = '[im].[account]';
                },
                element: el => el.attr('placeholder', '-- Select Table --')
                    .css('float', 'left')
                    .css('width', '300px')
                    .insertAfter(this.toolbar.element.find('.s-QuickSearchBar'))
            });

            this.schemaAndTable.changeSelect2(e => {
                this.view.setItems([], true);
                this.refresh()
            });
        }

        private get tableSchema() {
            return Q.replaceAll(Q.replaceAll(this.schemaAndTable.value || '', '[', ''), ']', '').split('.')[0];
        }

        private get tableName() {
            return Q.replaceAll(Q.replaceAll(this.schemaAndTable.value || '', '[', ''), ']', '').split('.')[1];
        }

        initDialog(dlg: any) {
            super.initDialog(dlg);
            (dlg as ExtensionFieldDialog).fieldNames = this.getItems();
            var m = this.getItems().filter(x => x.DataType).map(x => x.DataType);
            if (Array['from'] && window['Set']) {
                m = Array['from'](new window['Set'](m));
            }
            (dlg as ExtensionFieldDialog).dataTypes = m;
        }

        addButtonClick() {
            if (!this.tableName) {
                Q.notifyWarning("Please select a table!");
                return;
            }

            this.editItem(<ExtensionFieldRow>{
                TableSchema: this.tableSchema,
                Tablename: this.tableName,
                MaxLength: 0,
                Width: 0,
                VisibleInForm: true,
                VisibleInGrid: true
            });
        }

        editItem(objectOrId: any) {
            if (typeof objectOrId == "string") {
                ExtensionFieldService.Retrieve({
                    TableSchema: this.tableSchema,
                    Tablename: this.tableName,
                    FieldName: objectOrId
                }, response => {
                    var item = this.view.getItemById(objectOrId);
                    if (item) {
                        response.Entity.DataType = item.DataType;
                        response.Entity.MaxLength = Q.coalesce(response.Entity.MaxLength, 0);
                        response.Entity.VisibleInForm = Q.coalesce(response.Entity.VisibleInForm, true);
                        response.Entity.VisibleInGrid = Q.coalesce(response.Entity.VisibleInGrid, true);
                        response.Entity.FormWidthUntilNext = Q.coalesce(response.Entity.FormWidthUntilNext, false);
                        response.Entity.FormWidthJustThis = Q.coalesce(response.Entity.FormWidthJustThis, false);
                        response.Entity.IsRequired = Q.coalesce(response.Entity.IsRequired, false);
                        response.Entity.LookupInclude = Q.coalesce(response.Entity.LookupInclude, false);
                        response.Entity.Cloneable = Q.coalesce(response.Entity.Cloneable, true);
                        response.Entity.Width = Q.coalesce(response.Entity.Width, 0);
                        this.editItem(response.Entity);
                    }
                })
            }
            else
                super.editItem(objectOrId);
        }

        getButtons() {
            var buttons = super.getButtons();
            var addIndex = Q.indexOf(buttons, x => x.cssClass == "add-button");
            buttons[addIndex].title = 'Add Extension Field';
            
            buttons.splice(addIndex + 1, 0, {
                cssClass: 'add-calculated-button',
                icon: 'fa-calculator',
                title: 'Add Calculated Field',
                onClick: () => {
                    if (!this.tableName) {
                        Q.notifyWarning("Please select a table!");
                        return;
                    }
                        
                    this.editItem(<ExtensionFieldRow>{
                        TableSchema: this.tableSchema,
                        Tablename: this.tableName,
                        Expression: ''
                    });
                }
            });

            buttons.splice(addIndex + 2, 0, {
                cssClass: 'parse-view-button',
                icon: 'fa-eye',
                title: 'Parse From DB',
                onClick: () => {

                    if (!this.tableName) {
                        Q.notifyWarning("Please select a table!");
                        return;
                    }

                    Q.confirm("This will read view from DB and might result in losing some extension fields defined here, continue?", () => {
                        ExtensionFieldService.Parse({
                            TableSchema: this.tableSchema,
                            Tablename: this.tableName
                        }, r => {
                            this.refresh();
                            Q.notifySuccess("Extension fields are updated from DB");
                        });
                    });
                }
            });

            buttons.splice(addIndex + 3, 0, {
                cssClass: 'restart-button',
                icon: 'fa-power-off text-red',
                title: 'Restart',
                onClick: () => {
                    ExtensionFieldService.Restart({}, response => Q.notifyInfo("Application is restarting..."));
                }
            });


            if (!Authorization.userDefinition.IsDevelopment)
                buttons = buttons.filter(x => x.cssClass != "add-button" && 
                    x.cssClass != "add-calculated-button" && 
                    x.cssClass != "restart-button" &&
                    x.cssClass != "parse-view-button");

            return buttons;
        }

        getGridCanLoad() {
            return super.getGridCanLoad() && !Q.isEmptyOrNull(this.schemaAndTable.value);
        }

        onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var request = this.view.params as Serenity.ListRequest;
            request.EqualityFilter = request.EqualityFilter || {};
            request.EqualityFilter[ExtensionFieldRow.Fields.TableSchema] = this.tableSchema;
            request.EqualityFilter[ExtensionFieldRow.Fields.Tablename] = this.tableName;

            return true;
        }

        usePager() {
            return false;
        }

        getItemCssClass(item: ExtensionFieldRow, index: number) {
            return (super.getItemCssClass(item, index) || '') +
                (Q.isEmptyOrNull(item.FieldAlias) ? "inactive" : "");
        }
    }
}

namespace System {
    export enum DateTimeKind {
        Unspecified = 0,
        Utc = 1,
        Local = 2
    }
    
    Serenity.Decorators.registerEnum(DateTimeKind, "System.DateTimeKind", "System.DateTimeKind");
}

namespace Serenity.Data.Mapping {
    
    export enum SearchType
    {
        Auto = 0,
        Equals = 1,
        Contains = 2,
        StartsWith = 3
    }

    Serenity.Decorators.registerEnum(SearchType, "Serenity.Data.Mapping.SearchType", "Serenity.Data.Mapping.SearchType");
}